export class GeneralInspectionModel {
    Id: number = 0;
    Date: Date = new Date();
    EquipmentId: number = 0;
    SMU: number = 0;
    Life: number = 0;
    DocketNo: string;
    TrammingHours: number = 0;
    CustomerContact: string;
    InspectionNotes: string;
    JobSite: JobsiteModel = new JobsiteModel();
    TrackSagLeft: number = 0;
    TrackSagRight: number = 0;
    DryJointsLeft: number = 0;
    DryJointsRight: number = 0;
    ExtCannonLeft: number = 0;
    ExtCannonRight: number = 0;
    Impact: number = 0;
    Abrasive: number = 0;
    Moisture: number = 0;
    Packing: number = 0;
    JobSiteNotes: string;
    SMUValidationFailed: boolean = false;
    SMUMessage: string;

    ShoeCountRight: number;
    ShoeCountLeft: number;
    oldDate: Date = new Date();
  InspectionType: number;
  IsReleased: boolean;

  InterpComment: string;

}

export class JobsiteModel {
    Id: number = 0;
    CustomerId: number = 0;
    Title: string;
}

export class InspectionTypeVM{
    Id:number;
    Name:string;
}
export class EquipmentPhotoModel {
    CustomerModelMandatoryImageId: number;
    Id: number;
    Photo: string;
    Title: string;
    Description: string;
}

export class AdditionalRecordOverviewModel {
    Id: number;
    RecordId: number;
    Type: string;
}

export class AdditionalRecordModel {
    Name: string;
    Data: string;
    Image:string;
}

export class ComponentRecord {
    Id: number;
    Photo: string;
    Name: string;
    Position: string;
    WornPercentage: number;
    MeasurementPoints: MeasurementPointRecord[];
    CalculatedWorn:number;
    SUMWorn:number
}

export class MeasurementPointRecord {
    Id: number;
    CompartMeasurementPointId: number;
    Photo: string;
    WornPercentage: number;
    Name: string;
    AverageReading: string;
    Comment: string;
    Photos: MeasurementPointPhoto[];
    Readings: MeasurementPointReading[];
    ContributionWornPercentage:number;
    HasEstimateMeasurement:boolean;
    startingEndDim:string;
    ReportConfigData:ReportConfigVM;
}

export class MeasurementPointPhoto {
    Id: number;
    Photo: string;
    Title: string;
    Comment: string;
}

export class MeasurementPointReading {
    Id: number;
    WornPercentage: number;
    Measurement: number;
    ToolId: number;
    Text: string;
    IsEstimate:boolean;
}

export class MandatoryCompartPhoto {
    Id: number;
    Photo: string;
    Title: string;
    Comment: string;
}

export enum Tool {
    InvalidTool = -1,
    Ruler = 1,
    DepthGuage,
    UT,
    Calipers,
    KeeperOrientation,
    DriveLugsEngaged,
    YESorNO,
    Observation,
    Eval,
    passFail
}

export class MandatoryEquipmentPhotoModel {
    constructor(inspectionId: number, customerModelMandatoryImageId: number, photo: string, recordId: number) {
        this.InspectionId = inspectionId;
        this.MandatoryImageId = customerModelMandatoryImageId;
        this.Photo = photo;
        this.PhotoRecordId = recordId;
    }
    InspectionId: number;
    MandatoryImageId: number;
    Photo: string;
    PhotoRecordId: number;
}

export class MandatoryCompartTypePhotoModel {
    constructor(inspectionId: number, customerModelMandatoryImageId: number, photo: string, recordId: number, side: number) {
        this.InspectionId = inspectionId;
        this.MandatoryImageId = customerModelMandatoryImageId;
        this.Photo = photo;
        this.PhotoRecordId = recordId;
        this.Side = side;
    }
    InspectionId: number;
    MandatoryImageId: number;
    Photo: string;
    Side: number;
    PhotoRecordId: number;
}

export class MeasurementPointPhotoModel {
    constructor(recordId: number, photoData: string) {
        this.PhotoData = photoData;
        this.RecordId = recordId;
    }
    RecordId: number;
    PhotoData: string;
}

export class NewMeasurementPointPhotoModel {
  InspectionDetailId: number;
  CompartMeasurePointId: number;
  Photo: string;

  constructor(private inspectionDetailId: number,
    private compartMeasurePointId: number,
    private photo: string) {
    this.InspectionDetailId = inspectionDetailId;
    this.CompartMeasurePointId = compartMeasurePointId;
    this.Photo = photo;
  }
}

export class ToolList{
    ToolId:number;
    ToolName:string;
}

export class UnitOfMeasurement {
  Id: number;
  UOM: string;
}

export  class RSHMainMPInfo{
    public CompartMPId:number;
    public possibletools:ToolList[];
  public Name: string;
  public UnitOfMeasurement: UnitOfMeasurement[];
}

export enum ReportConfigOptions {
  InvalidTool = -1,
  Ruler = 1,
  DepthGuage,
  UT,
  Calipers,
  KeeperOrientation,
  DriveLugsEngaged,
  YESorNO,
  Observation,
  Eval
}
export class ReportConfigVM {
  public Id: number;
  public InspectionId: number;
  public InspectionDetailId: number;
  public CompartTypeId: number;
  public CompartMeasurementPointId: number;
  public CompartType: string;
  public MiningShovelReportId: number;
  public MiningShovelReportConfigId: number;
  public IncludeMeasurementImage: boolean;
  public IncludeObservationsTable: boolean;
  public IncludeGraph: boolean;
  public IncludeImages: boolean;
  public IncludeComments: boolean;
  public CreatedDate: Date;
  public CreatedBy: number;
  public UpdatedDate: Date;
  public UpdatedBy: number;
  public SortOrder: number;
  public OptionType: string;
  public OptionTypeChecked: boolean;
  public Side: number;
}
